<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar
      left-text="返回"
      fixed
      title="门店信息"
      left-arrow
      right-text="修改门店信息"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
    </van-nav-bar>
    <!--导航栏 end-->
    <!--内容 start-->
    <div style="margin-top: 1.5rem">
      <van-cell-group>
        <van-cell title="门店编号" :value="list.store_num" />
        <van-cell title="门店名称" :value="list.store_name" />
        <van-cell title="门店联系人" :value="list.store_contact" />
        <van-cell title="联系人电话" :value="list.store_tel" />
        <van-cell title="门店信息" :value="list.store_info" />
        <van-cell title="门店图片">
          <template #right-icon>
            <van-image
              width="50"
              height="50"
              :src="Config.baseURL + list.store_img"
            />
          </template>
        </van-cell>
        <van-cell title="D0结算费率" :value="list.d0_rate" />
        <!-- <van-cell title="D1结算费率" :value="list.d1_rate" /> -->
        <van-cell title="入驻时间" :value="list.create_time" />
        <van-cell
          title="是否营业"
          :value="['暂停营业', '开业'][list.store_is_start]"
        />
        <van-cell title="门店地址">
          <template #label>
            <div class="label">
              <span> {{ list.store_address }}</span>
              <!-- <div class="button" @click="changeAddress">修改</div> -->
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <!--内容 end-->
    <changeMap
      v-if="is_map"
      style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 999;"
      @getLocation="getLoacation"
    ></changeMap>
  </div>
</template>

<script>
import Config from "../../../config";
import changeMap from "@/components/map.vue";
export default {
  name: "StoresStoreInformation", //门店信息
  components: {
    changeMap,
  },
  data() {
    return {
      is_map: false,
      list: [],
    };
  },
  created() {
    this.merchant_id = this.$route.query.merchant_id;
    this.store_id = this.$route.query.store_id;
  },
  mounted() {
    this.choose();
  },

  methods: {
    getLoacation(res) {
      this.is_map = false;
      this.list.store_address = res.poiaddress;
      var reqData = {
        store_lng: res.latlng.lng,
        store_lat: res.latlng.lat,
        store_address: res.poiaddress,
      };
      this.$http
        .post("/wechat/api.store.index/editStore", reqData)
        .then((res1) => {
          console.log(res1);
          var res = res1.body;
          this.$toast.success(res.msg);
        })
        .catch((err) => {
          this.$toast.fail("操作失败");
        });
    },
    changeAddress() {
      this.is_map = true;
    },
    // 返回上一级
    onClickLeft() {
      this.$router.push({
        path: "/OpenOrderCode",
        query: { merchant_id: this.merchant_id, store_id: this.store_id },
      });
    },
    // 右侧跳转修改门店
    onClickRight() {
      // 跳转修改门店
      this.$router.push({
        path: "/StoreInfoUpdate",
        query: { merchant_id: this.merchant_id, store_id: this.store_id },
      });
    },

    //选择每个门店
    choose() {
      this.$http
        .get("/wechat/api.salesman/get_store_info", {
          params: {
            merchant_id: this.merchant_id,
            store_id: this.store_id,
          },
        })
        .then((response) => {
          this.list = response.data.data;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .button {
    width: 40px;
    height: 20px;
    background-color: #1989fa;
    text-align: center;
    line-height: 20px;
    border-radius: 2px;
    font-size: 10px;
    color: #fff;
  }
}
</style>
